/* <age-gate> — 18+ doğrulama; seçim localStorage'da 30 gün */
class AgeGate extends HTMLElement {
  static KEY = 'cpl-age-verified';
  static TTL = 30 * 24 * 60 * 60 * 1000;

  connectedCallback() {
    if (this.isVerified()) return;
    this.querySelector('[data-age-confirm]')?.addEventListener('click', () => this.confirm());
    this.open();
  }
  isVerified() {
    try {
      const until = parseInt(localStorage.getItem(AgeGate.KEY) || '0', 10);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  }
  open() {
    this.hidden = false;
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => this.classList.add('is-open'));
    const panel = this.querySelector('[role="dialog"]');
    /* Seçim zorunlu: Esc kapatmaz, odak katmanda kalır */
    window.CPL?.trapFocus(panel, this.querySelector('[data-age-confirm]') || panel);
  }
  confirm() {
    try {
      localStorage.setItem(AgeGate.KEY, String(Date.now() + AgeGate.TTL));
    } catch (e) {
      /* depolama yoksa yalnızca bu oturum */
    }
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    window.CPL?.removeTrapFocus();
    setTimeout(() => (this.hidden = true), 200);
  }
}
if (!customElements.get('age-gate')) customElements.define('age-gate', AgeGate);
